//basic-card
export const basicCardSubTitle = [{ text: 'This is a simple basic card using anywhere.' }];

export const flatCardSubTitle = [
    {
        text: 'For flat cards, make the',
        code: '.b-r-0[border-radius:0] '
    },
    {
        text: 'used class.'
    }
];

export const withoutShadowSubTitle = [
    {
        text: 'Use the',
        code: '.shadow-none '
    },
    {
        text: '&',
        code: '.border '
    },
    {
        text: 'class through shadow removes.'
    }
];

export const darkCardSubTitle = [
    {
        text: 'Use the ',
        code: ' .bg-dark '
    },
    {
        text: 'color for dark background card.'
    }
]